import React from "react";
import { useTranslation } from "react-i18next";
import { IconX } from "@tabler/icons-react";
import { LangConstant } from "const";

const MessageStatisticDialog = ({ open, onClose, message }) => {
  const { t: getLabel } = useTranslation();

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal modal-blur fade show" style={{ display: "block" }} tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div
              className="modal-header"
              style={{ backgroundColor: "var(--tblr-bg-surface-secondary)", height: "50px", display: "flex", alignItems: "center", padding: "8px" }}
            >
              <h5 className="modal-title" style={{ fontWeight: 700, textAlign: "center", fontSize: 20, width: "95%", paddingLeft: "16px" }}>
                {getLabel(LangConstant.TXT_MEDIA_STATISTIC_TITLE)}
              </h5>
              <button className="btn btn-icon btn-ghost-secondary" onClick={onClose}>
                <IconX size={20} />
              </button>
            </div>

            <div className="modal-body" style={{ display: "flex", gap: "2px", backgroundColor: "var(--tblr-bg-surface-secondary)", padding: "0" }}>
              <div style={{ width: "700px", backgroundColor: "var(--tblr-bg-surface)", padding: "16px" }}>
                <p>{getLabel(LangConstant.TXT_MEDIA_TOTAL_SENT)}</p>
                <div style={{ fontSize: 24, color: "#008FE8", fontWeight: "bold" }}>
                  {message.statistic_message?.success_send}/{message.statistic_message?.total_send}
                </div>
                <p>{getLabel(LangConstant.TXT_MEDIA_SEND_SUCCESS_RATE)}</p>
                <div style={{ fontSize: 24, color: "#008FE8", fontWeight: "bold" }}>
                  {(message.statistic_message?.success_send / message.statistic_message?.total_send).toFixed(2) * 100 || 0}%
                </div>
              </div>
              <div style={{ width: "700px", backgroundColor: "var(--tblr-bg-surface)", padding: "16px" }}>
                <p>{getLabel(LangConstant.TXT_MEDIA_TOTAL_RECEIVED)}</p>
                <div style={{ fontSize: 24, color: "#008FE8", fontWeight: "bold" }}>
                  {message.statistic_message?.total_receive}/{message.statistic_message?.success_send}
                </div>
                <p>{getLabel(LangConstant.TXT_MEDIA_RECEIVE_SUCCESS_RATE)}</p>
                <div style={{ fontSize: 24, color: "#008FE8", fontWeight: "bold" }}>
                  {(message.statistic_message?.total_receive / message.statistic_message?.success_send).toFixed(2) * 100 || 0}%
                </div>
              </div>
              <div style={{ width: "700px", backgroundColor: "var(--tblr-bg-surface)", padding: "16px" }}>
                <p>{getLabel(LangConstant.TXT_MEDIA_TOTAL_READ)}</p>
                <div style={{ fontSize: 24, color: "#008FE8", fontWeight: "bold" }}>
                  {message.statistic_message?.total_read}/{message.statistic_message?.success_send}
                </div>
                <p>{getLabel(LangConstant.TXT_MEDIA_READ_RATE)}</p>
                <div style={{ fontSize: 24, color: "#008FE8", fontWeight: "bold" }}>
                  {(message.statistic_message?.total_read / message.statistic_message?.success_send).toFixed(2) * 100 || 0}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MessageStatisticDialog;
